module.exports = __webpack_public_path__ + "static/home-driveway2-3624a26c8a7307660176c33eaec12757.jpg";